import { ActionType, getType } from 'typesafe-actions';

import * as config from '../../actionCreators/config';

const initialState = null;

export default function (
  state: PayLaterRule[] | null = initialState,
  action: ActionType<typeof config>,
): PayLaterRule[] | null {
  switch (action.type) {
    case getType(config.setPayLaterRules): {
      const { value } = action.payload;
      return value || initialState;
    }
    default:
      return state;
  }
}
